<template>
    <div class="relative">
      <div v-if="count > 0" class="absolute -top-1/2 -right-1/2 rounded-full bg-green-300 text-white text-center h-4 w-4 text-xs font-bold">
        {{count}}
      </div>
        <slot />
    </div>
</template>

<script>
export default {
  props: {
    count: Number,
  },
}
</script>
